import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
/** Care analytics site events — distinct from conversion-funnel taxonomy. Observe-only. */
export const CareSiteEventTypeSchema = z.enum([
    "PAGE_VIEW",
    "FORM_SUBMIT",
    "CALL_CLICK",
    "IMPORTANT_CLICK",
]);
export const CareInstrumentationKeySchema = z
    .string()
    .regex(/^cins_[a-zA-Z0-9_-]+$/)
    .brand();
export const CareSiteEventIdSchema = z
    .string()
    .regex(/^cev_[a-zA-Z0-9_-]+$/)
    .brand();
export const CareConsentModeSchema = z.enum(["REQUIRED", "OPTIONAL", "DISABLED"]);
export const CareEventConsentConfigV1Schema = z
    .object({
    schemaVersion: z.literal("care-event-consent-config.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    instrumentationKey: CareInstrumentationKeySchema,
    consentMode: CareConsentModeSchema,
    /** Declared event types the tenant opted into collecting. */
    enabledEventTypes: z.array(CareSiteEventTypeSchema).min(1),
    updatedAt: z.string().datetime(),
})
    .strict();
export const CareSiteEventCaptureRequestV1Schema = z
    .object({
    schemaVersion: z.literal("care-site-event-capture.v1.0"),
    instrumentationKey: CareInstrumentationKeySchema,
    eventType: CareSiteEventTypeSchema,
    visitorConsentGranted: z.boolean(),
    occurredAt: z.string().datetime().optional(),
    pagePath: z.string().max(512).optional(),
    elementId: z.string().max(128).optional(),
    sessionKey: z.string().max(128).optional(),
    metadata: z.record(z.string(), z.union([z.string(), z.number(), z.boolean()])).optional(),
})
    .strict();
export const CareSiteEventAcceptedV1Schema = z
    .object({
    schemaVersion: z.literal("care-site-event-accepted.v1.0"),
    eventId: CareSiteEventIdSchema,
    acceptedAt: z.string().datetime(),
})
    .strict();
export function careEventCollectionAllowed(config, eventType, visitorConsentGranted) {
    if (config.consentMode === "DISABLED") {
        return { allowed: false, reason: "instrumentation_disabled" };
    }
    if (!config.enabledEventTypes.includes(eventType)) {
        return { allowed: false, reason: "event_type_not_enabled" };
    }
    if (config.consentMode === "REQUIRED" && !visitorConsentGranted) {
        return { allowed: false, reason: "consent_required" };
    }
    return { allowed: true };
}
//# sourceMappingURL=care-site-events.js.map